import fetch from '../utils/fetch';
// import fetch from '../utils/fetch'
import { baseUrl } from '../utils/env';


export const ajaxAutoWithList = (data) => {
  return fetch(baseUrl + '/api/withdrawalAuto/getAutoWithList', data);
};
export const ajaxOperateBalance = (data) => {
  return fetch(baseUrl + '/api/crm/setBalance', data);
};
export const ajaxBalanceList = (data) => {
  return fetch(baseUrl + '/api/crm/getBalanceList', data);
};
export const ajaxInfo = (data) => {
  return fetch(baseUrl + '/api/getGithub', data);
};
